import Vue       from 'vue'
import VueRouter from 'vue-router'
import store     from '@/store'
import HomeView  from '@/views/HomeView.vue'

// Auth
import LoginView             from '@/views/LoginView.vue'
import ClientePanelView      from '@/views/ClientePanelView.vue'
import OlvidePasswordView    from '@/views/OlvidePasswordView.vue'
import RestablecerPasswordView from '@/views/RestablecerPasswordView.vue'

// Admin
import AdminLayout              from '@/views/AdminLayout.vue'
import SistemasView             from '@/views/catalogos/Sistemas.vue'
import PlanesView               from '@/views/catalogos/Planes.vue'
import CaracteristicasPlanView  from '@/views/catalogos/CaracteristicasPlan.vue'

// Administración
import ClientesAdminView         from '@/views/administracion/Clientes.vue'
import SistemasClientesAdminView from '@/views/administracion/SistemasClientes.vue'
import PromocionesAdminView      from '@/views/administracion/Promociones.vue'

Vue.use(VueRouter)

const routes = [
  {
    path:      '/',
    name:      'Home',
    component: HomeView
  },
  {
    path:      '/login',
    name:      'Login',
    component: LoginView,
    meta:      { publico: true }
  },
  {
    path:      '/olvide-password',
    name:      'OlvidePassword',
    component: OlvidePasswordView,
    meta:      { publico: true }
  },
  {
    path:      '/restablecer-password',
    name:      'RestablecerPassword',
    component: RestablecerPasswordView,
    meta:      { publico: true }
  },
  {
    path:      '/cliente',
    name:      'ClientePanel',
    component: ClientePanelView,
    meta:      { requiereAuth: true, soloCliente: true }
  },
  {
    path:      '/admin',
    component: AdminLayout,
    meta:      { requiereAuth: true, soloAdmin: true },
    children: [
      {
        path:      '',
        redirect:  'sistemas'
      },
      {
        path:      'sistemas',
        name:      'AdminSistemas',
        component: SistemasView
      },
      {
        path:      'planes/:idSistema?',
        name:      'AdminPlanes',
        component: PlanesView,
        props:     true
      },
      {
        path:      'caracteristicas/:idPlan?',
        name:      'AdminCaracteristicas',
        component: CaracteristicasPlanView,
        props:     true
      },
      {
        path:      'clientes',
        name:      'AdminClientes',
        component: ClientesAdminView
      },
      {
        path:      'sistemas-clientes',
        name:      'AdminSistemasClientes',
        component: SistemasClientesAdminView
      },
      {
        path:      'promociones',
        name:      'AdminPromociones',
        component: PromocionesAdminView
      }
    ]
  },
  // Ruta comodín
  {
    path:     '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// ── Guards de navegación ──────────────────────────────────────────────
router.beforeEach((to, from, next) => {
  const token    = localStorage.getItem('token')
  const idRol    = parseInt(localStorage.getItem('idRol') || '0')
  const estaAuth = !!token

  // console.log('🔐 Guard ejecutado:', {
  //   destino: to.name,
  //   desde: from.name,
  //   autenticado: estaAuth,
  //   idRol: idRol
  // })

  // Usar to.matched para heredar meta del padre (/admin) a las rutas hijas
  const requiereAuth = to.matched.some(r => r.meta.requiereAuth)
  const soloAdmin    = to.matched.some(r => r.meta.soloAdmin)
  const soloCliente  = to.matched.some(r => r.meta.soloCliente)
  const esPublico    = to.matched.some(r => r.meta.publico)

  // Sin sesión en ruta protegida → login
  if (requiereAuth && !estaAuth) {
    console.warn('❌ Sin sesión en ruta protegida. Redirigiendo a login.')
    return next({ name: 'Login' })
  }

  // Panel admin → solo rol 1; cualquier otro va al login
  if (soloAdmin && idRol !== 1) {
    console.warn(`❌ Acceso denegado a admin. idRol: ${idRol}. Redirigiendo a login.`)
    return next({ name: 'Login' })
  }

  // Panel cliente → solo rol 2; cualquier otro va al login
  if (soloCliente && idRol !== 2) {
    console.warn(`❌ Acceso denegado a cliente. idRol: ${idRol}. Redirigiendo a login.`)
    return next({ name: 'Login' })
  }

  // Ya autenticado e intenta ir al login → redirigir a su panel
  // (excepto si viene con ?logout=1 desde un sistema externo)
  if (to.name === 'Login' && estaAuth) {
    if (to.query.logout === '1') {
      localStorage.removeItem('token')
      localStorage.removeItem('idUsuario')
      localStorage.removeItem('nombre')
      localStorage.removeItem('email')
      localStorage.removeItem('idRol')
      localStorage.removeItem('nombreRol')
      store.commit('CLEAR_AUTH')
      console.log('🚪 Sesión cerrada.')
      return next()
    }

    // Validar que idRol sea válido (1 o 2)
    if (idRol === 1) {
      //console.log('✅ Autenticado como Admin. Redirigiendo a AdminSistemas.')
      return next({ name: 'AdminSistemas' })
    } else if (idRol === 2) {
      //console.log('✅ Autenticado como Cliente. Redirigiendo a ClientePanel.')
      return next({ name: 'ClientePanel' })
    } else {
      //console.error(`❌ idRol inválido: ${idRol}. Limpiando localStorage y redirigiendo a login.`)
      localStorage.removeItem('token')
      localStorage.removeItem('idUsuario')
      localStorage.removeItem('nombre')
      localStorage.removeItem('email')
      localStorage.removeItem('idRol')
      localStorage.removeItem('nombreRol')
      return next()
    }
  }

  next()
})

export default router
